import { render } from "./GlossaryUsage.vue?vue&type=template&id=a2db382a&scoped=true&ts=true"
import script from "./GlossaryUsage.vue?vue&type=script&lang=ts"
export * from "./GlossaryUsage.vue?vue&type=script&lang=ts"

import "./GlossaryUsage.vue?vue&type=style&index=0&id=a2db382a&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2db382a"]])

export default __exports__